var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8.6L0 4.4l20.5 20.5-7.3 16.9h8.9l4.7-10.7 16.6 16.6 3.8-3.8L4.6 1.4 3.8.6zm8 0v.6l8.3 8.3h7.1L25 14.4l6.2 6.2L36 9.5h11.9V.6H11.8z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNMy44LjZMMCA0LjRsMjAuNSAyMC41LTcuMyAxNi45aDguOWw0LjctMTAuNyAxNi42IDE2LjYgMy44LTMuOEw0LjYgMS40IDMuOC42em04IDB2LjZsOC4zIDguM2g3LjFMMjUgMTQuNGw2LjIgNi4yTDM2IDkuNWgxMS45Vi42SDExLjh6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";
export { SvgClear as ReactComponent };